/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Spell_Numbers_Start_LabelInputs */

const en_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell Numbers At Start Of Line`)
};

const fr_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epeler les nombres en debut de ligne`)
};

const de_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibe die Zahlen am Zeilenanfang.`)
};

const it_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi i numeri all'inizio della riga`)
};

const ru_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Напишите цифры в начале строки`)
};

const es_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deletrear números al comienzo de la línea`)
};

const zh_cn2_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在行首拼写数字`)
};

const ja_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行頭に数字を入力する`)
};

const hi_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंक्ति के प्रारंभ में संख्याओं की वर्तनी लिखें`)
};

const pt_pt2_style_guide_manager_spell_numbers_start_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva os números por extenso no início da linha.`)
};

/**
* | output |
* | --- |
* | "Spell Numbers At Start Of Line" |
*
* @param {Style_Guide_Manager_Spell_Numbers_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_spell_numbers_start_label = /** @type {((inputs?: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Spell_Numbers_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "de") return de_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "it") return it_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "es") return es_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_spell_numbers_start_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_spell_numbers_start_label(inputs)
	return en_style_guide_manager_spell_numbers_start_label(inputs)
});